import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/scan-orange.svg'


const _hoisted_1 = { class: "header mb-5" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search color-primary font-semibold text-lg" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "color-primary text-lg font-semibold" }, "Cari Manual", -1)
const _hoisted_6 = {
  key: 1,
  class: "flex w-3/7"
}
const _hoisted_7 = { class: "flex justify-end color-red text-sm" }
const _hoisted_8 = { class: "flex w-full container-input-scan-resi" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  alt: "miisi-logo",
  src: "/img/milsi-logo.png",
  class: "mr-2",
  style: {"height":"11px"}
}
const _hoisted_12 = { class: "color-blue-grey-darken-1 font-bold mr-4 text-base" }
const _hoisted_13 = { class: " flex w-full justify-between gap-4" }
const _hoisted_14 = { class: "block sm:flex gap-10 mt-5" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: " text-xs color-blue-grey-lighten-1 mb-2" }, "Pengirim", -1)
const _hoisted_17 = { class: "color-blue-grey-darken-1 font-bold text-sm mb-2" }
const _hoisted_18 = { class: "color-blue-grey-darken-1 font-bold text-sm" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: " text-xs color-blue-grey-lighten-1 mb-2" }, "Penerima", -1)
const _hoisted_21 = { class: "color-blue-grey-darken-1 font-bold text-sm mb-2" }
const _hoisted_22 = { class: "color-blue-grey-darken-1 font-bold text-sm" }
const _hoisted_23 = { class: "mb-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: " text-xs color-blue-grey-lighten-1 mb-2" }, "Jenis", -1)
const _hoisted_25 = { class: "color-blue-grey-darken-1 text-4xl font-extrabold" }
const _hoisted_26 = { class: "mt-5 sm:mt-0" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Proses Transaksi ")
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-right font-bold ml-2" }, null, -1)
const _hoisted_29 = { class: "flex items-end gap-2 justify-end" }
const _hoisted_30 = { class: "color-blue-grey-darken-1 text-3xl font-extrabold" }
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-darken-1 text-lg mt-4" }, "Total Koli", -1)
const _hoisted_32 = { class: "footer mt-10" }
const _hoisted_33 = { class: "p-col-12 block" }
const _hoisted_34 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Clear Filter")
const _hoisted_36 = { class: "flex justify-center" }
const _hoisted_37 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DialogDetailResiV2 = _resolveComponent("DialogDetailResiV2")
  const _component_QrScanner = _resolveComponent("QrScanner")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (!_ctx.showSearch)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "flex gap-2 items-center cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearch = true))
              }, [
                _hoisted_4,
                _hoisted_5
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedSearchOption,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedSearchOption = $event)),
                  options: _ctx.searchOptions,
                  onChange: _ctx.onChangeSelectedSearchOption,
                  optionLabel: "name",
                  optionValue: "value",
                  class: "input-primary"
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode(_component_InputIconRightGrey, {
                  placeholder: "Cari Disini ...",
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputSearch = $event)),
                  type: _ctx.enumBase.input.text,
                  icon: _ctx.icon.svg.searchEva,
                  onKeypress: _withKeys(_ctx.processSearch, ["enter"])
                }, null, 8, ["modelValue", "type", "icon", "onKeypress"])
              ]))
        ]),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.errorSearchMessage), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("img", {
          src: _imports_0,
          class: "icon-scan-input w-10",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScan && _ctx.onScan(...args)))
        }),
        _createVNode(_component_InputText, {
          placeholder: "Scan QR paket dari mobile apps",
          ref: "inputCekResi",
          class: "input-pengecekan-resi input-primary w-full",
          modelValue: _ctx.inputScanResi,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.inputScanResi = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDrafts, (draft, idx) => {
        return (_openBlock(), _createBlock("div", {
          class: "card-draft mb-5",
          key: idx
        }, [
          _createVNode("div", _hoisted_10, [
            (draft.Tags)
              ? (_openBlock(), _createBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            _createVNode("p", _hoisted_12, _toDisplayString(`${draft.AgenAsalNama} - ${draft.AgenTujuanNama}`), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("p", _hoisted_17, _toDisplayString(draft.NamaPengirim), 1),
                _createVNode("p", _hoisted_18, _toDisplayString(draft.HpPengirim), 1)
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("p", _hoisted_21, _toDisplayString(draft.NamaPenerima), 1),
                _createVNode("p", _hoisted_22, _toDisplayString(draft.HpPenerima), 1)
              ]),
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("p", _hoisted_25, _toDisplayString(draft.TipePengiriman), 1)
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", {
                class: "color-primary font-bold cursor-pointer",
                onClick: ($event: any) => (_ctx.onProcessTrans(draft))
              }, [
                _hoisted_27,
                _hoisted_28
              ], 8, ["onClick"]),
              _createVNode("div", _hoisted_29, [
                _createVNode("p", _hoisted_30, _toDisplayString(draft.TotalColly), 1),
                _hoisted_31
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_32, [
      (_ctx.dataDrafts.length > 0)
        ? (_openBlock(), _createBlock(_component_Paginator, {
            key: 0,
            rows: _ctx.filters.pageSize,
            totalRecords: _ctx.filters.totalRecords,
            onPage: _ctx.onPage
          }, null, 8, ["rows", "totalRecords", "onPage"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "filterCal",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_33, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: "range"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_34, [
            (_ctx.dateFilter.length > 1)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black p-button-sm px-10 py-1",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearFilter()))
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.isShowDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResiV2, {
          key: 0,
          isShowDialog: _ctx.isShowDetail,
          onHideDialog: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowDetail = false)),
          idTrans: _ctx.draftSelect?.Id,
          module: "delivery-draft",
          closable: true,
          tags: _ctx.draftSelect?.Tags
        }, null, 8, ["isShowDialog", "idTrans", "tags"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.isDialogCamera,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isDialogCamera = $event)),
      modal: true,
      style: { width: '70vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_37, [
          _createVNode(_component_Button, {
            label: "Kembali",
            class: "font-semibold p-button-sm btn-primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDialogCamera = false))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_36, [
          (_ctx.isDialogCamera)
            ? (_openBlock(), _createBlock(_component_QrScanner, {
                key: 0,
                class: "qr-draft",
                onOnDetect: _ctx.onDetectScanner
              }, null, 8, ["onOnDetect"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}